import { RefObject } from "react";

import Button from "client/common/components/buttons/Button";

import { IProductLineDetails } from "../types";

import styles from "../styles/ProductLineOptionsBar.module.less";

type ProductLineOptionsBarProps = {
  selectionRef: RefObject<HTMLDivElement | null>;
  productLine: IProductLineDetails;
};

const ProductLineOptionsBar = ({ selectionRef, productLine }: ProductLineOptionsBarProps) => {
  const handleClick = () => {
    selectionRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className={styles.container}>
      <div className={styles.banner}>
        <p className={styles.name}>
          <span className={styles.short}>{productLine.brand_name}</span>
          <span className={styles.long}>{productLine.name}</span>
        </p>
        <div className={styles.actions}>
          <Button size="s" onClick={handleClick}>
            {productLine.products.length ? "Select Strength" : "Select Dose"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ProductLineOptionsBar;
